import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const SignatureOrigin = ({ onRegisterClick }) => {
  return (
    <div className="relative py-24 text-white overflow-hidden">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[#0A0A0B]"></div>
        <img 
          src="https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/mwc6vfaf_Screenshot%202026-03-19%20at%2010.29.33%20AM.png"
          alt="Background Pattern"
          className="absolute inset-0 w-full h-full object-cover opacity-5"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-[#0A0A0B]/95 to-[#0A0A0B]"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left Image - New Goals Collage */}
          <div className="flex-1">
            <div className="relative">
              {/* Gradient glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#F5A623]/30 via-[#F5A623]/10 to-transparent rounded-3xl blur-3xl"></div>
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#F5A623]/20 to-transparent rounded-3xl blur-2xl"></div>
              
              {/* Floating image */}
              <img 
                src="https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/l2wy1ekq_Screenshot%202026-03-19%20at%2012.38.04%20PM.png"
                alt="What is Your Goal - Success Stories"
                className="relative w-full h-auto object-contain rounded-2xl shadow-2xl"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="flex-1 space-y-6">
            <p className="text-[#F5A623] text-sm font-semibold tracking-wider uppercase">
              The Power of Personal Qi
            </p>
            <h2 className="text-5xl font-bold leading-tight">
              Your <span className="italic text-[#F5A623]">Signature</span> Is Not Art.<br />
              It's a Wealth Structure.
            </h2>
            
            <p className="text-lg text-gray-300 leading-relaxed">
              In Feng Shui, we analyze homes and offices to gauge the level of success and harmony a person enjoys. A well-balanced space fosters prosperity, while a cluttered or misaligned one can block opportunities.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed">
              But have you ever considered applying this same principle to something even more personal—your signature?
            </p>

            <p className="text-lg text-gray-300 leading-relaxed">
              Your signature is a personal energy imprint. It appears on your contracts, business deals, financial documents, and personal correspondences. If it carries weak energy, it could be blocking your financial flow and career growth without you even realizing it!
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button 
                onClick={onRegisterClick}
                className="bg-[#F5A623] hover:bg-[#E59400] text-black font-bold px-8 py-3 rounded-lg group"
              >
                Join Free Webinar
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureOrigin;